import React, { createContext, useEffect, useState } from "react";
import service from "./utils/request";

export const SpaceContext = createContext(null);

export const SpaceProvider = ({ children }) => {
	const [users, setUsers] = useState([]);
	const [coolApps, setCoolApps] = useState([]);
	const [isLogin, setIsLogin] = useState(false);
	const [checkingAuth, setCheckingAuth] = useState(true);
	const [companies, setCompanies] = useState([]);
	const [offices, setOffices] = useState([]);
	const [departments, setDepartments] = useState([]);
	const [levels, setLevels] = useState([]);
	const [userProfile, setUserProfile] = useState({
		role_id: 0,
	});

	const getFilteredSpaces = async () => {
		const rawSpacesData = await service.get("/filer/space"); // return list of (space_id, space_name, space_class)
		if (!Array.isArray(rawSpacesData)) return;
		const mappedSpaces = rawSpacesData.map((space) => ({
			id: space[0],
			caption: space[1],
			class: space[2],
			shared: space[2] === 'share',
		}));
		const userSpaces = mappedSpaces.filter((space) => space.class === "user");
		const otherSpaces = mappedSpaces.filter((space) => space.class !== "user");
		const filteredSpaces = [
			...userSpaces,
			{ id: 'library', caption: 'Library', class: 'special' },
			...otherSpaces,
			{ id: "favour", caption: "Favour", class: "special", shared: false },
			{ id: "recent", caption: "Recent", class: "special", shared: false },
			{ id: "search", caption: "Search", class: "special", shared: true },
			{ id: "explorer", caption: "Explorer", class: "special", shared: true },
			{ id: "trash", caption: "Trash", class: "special", shared: false }
		];
		return filteredSpaces;
	}

	const getCurrentFolderPath = () => {
		const spaces = sessionStorage.getItem("path");
		if (!spaces || spaces.length == 0) {
			return "";
		}
		const path = JSON.parse(spaces).map(space => space.name).join(" ");
		return path;
	}

	useEffect(() => {
		const data = localStorage.getItem("collab_apps");
		if (data) {
			setCoolApps(JSON.parse(data));
		} else {
			service
				.get("/filer/discovery")
				.then((res) => {
					localStorage.setItem("collab_apps", JSON.stringify(res));
					setCoolApps(res);
				})
				.catch((error) => {
					console.error("Error fetching cool apps:", error);
				});
		}
	}, []);

	useEffect(() => {
		service.get("/user/profile")
			.then((res) => {
				setUserProfile(res);
				setIsLogin(true);
				service.get("/user_management/all").then((res) => setUsers(res)).catch(() => {});
				service.get("/user_management/companies").then((res) => setCompanies(res)).catch(() => {});
				service.get("/user_management/offices").then((res) => setOffices(res)).catch(() => {});
				service.get("/user_management/departments").then((res) => setDepartments(res)).catch(() => {});
				service.get("/user_management/levels").then((res) => setLevels(res)).catch(() => {});
			})
			.catch(() => {
				setIsLogin(false);
			})
			.finally(() => {
				setCheckingAuth(false);
			});
	}, []);

	return (
		<SpaceContext.Provider
			value={{coolApps, users, isLogin, setIsLogin, checkingAuth, setCheckingAuth, companies, offices, departments, levels, setUsers, userProfile, getFilteredSpaces, getCurrentFolderPath }}>
			{children}
		</SpaceContext.Provider>
	);
};
